/**
 * Rechtshinweis-Routen (R4, Entlastung Rahmen).
 *
 * Der Satz `t('b2bNotice')` ("Unser Angebot richtet sich ausschliesslich an
 * Unternehmer i.S.d. § 14 BGB.") sichert den KAUF ab, nicht den Betrieb.
 * Vorher rendert `Layout.tsx` ihn unter JEDER Seite, die durch den Rahmen
 * laeuft -- auch unter dem Feed-Check und der Werkbank, wo nie ein Preis
 * fällt. Seit R4 steht er als dezenter Fussnotenhinweis auf drei Routen:
 *
 * 1. `/auth` -- die Anmeldung ist der erste Schritt in Richtung Kauf.
 * 2. `/pricing` -- die Planwahl selbst.
 * 3. `/settings` -- dort liegt die Abo-/Rechnungsverwaltung (Tab-Query-
 *    Parameter wie `?tab=accounts` aendern `location.pathname` nicht, ein
 *    exakter Pfadvergleich reicht also fuer alle Settings-Tabs).
 *
 * Diese Liste bedient NUR `Layout.tsx` (Routen 2 und 3, die durch den
 * Rahmen laufen). Die Route `/auth` liegt in `src/App.tsx` AUSSERHALB von
 * `Layout` (kein `<Layout>`-Wrapper um `<Auth />`) und rendert den Hinweis
 * deshalb selbst in `src/pages/Auth.tsx` -- `Layout` sieht diese Route nie.
 *
 * WICHTIG (Final-Review-Fund F3, Korrektur einer zu weiten Behauptung): das
 * sind die Routen, auf denen der Fussnotenhinweis STEHT -- nicht alle Wege,
 * auf denen ein Kauf beginnen kann. `handleUpgrade` (`src/lib/checkout.ts`)
 * wird auch von `UpgradeBanner.tsx` (rendert in `<main>` auf JEDER Route
 * durch `Layout`), von `UpgradeModal.tsx` (oeffnet der `UsageIndicator` in
 * der Kopfleiste, ebenfalls ueberall) und von `PostFetchRecommendation.tsx`
 * aufgerufen -- ein Kauf kann also z. B. auch von `/` oder `/workbench` aus
 * beginnen, wo diese Liste den Fussnotenhinweis NICHT rendert. Diese drei
 * Wege tragen den Hinweis nicht selbst.
 *
 * Das ist bewusst so belassen, weil eine VIERTE Stelle jeden dieser Wege
 * unumgehbar abfaengt, BEVOR der Stripe-Redirect passiert: `handleUpgrade`
 * ruft als Erstes `requestB2BConfirmation()` auf (`src/lib/checkout.ts`,
 * `const confirmed = await requestB2BConfirmation(); if (!confirmed) return
 * { redirected: false };`) -- das oeffnet `B2BConfirmDialog`
 * (`src/components/checkout/B2BConfirmDialog.tsx`, Namespace `b2bDialog.*`),
 * dessen aktive, NICHT vorausgewaehlte Bestaetigung ein Kauf ohne sie gar
 * nicht erst absetzt. Damit ist die frueher offene Anwaltsfrage (BGH I ZR
 * 60/16, "klarer Hinweis auf jeder Seite",
 * docs/anwalt-anfrage-agb-preisumbau.md:39) zugunsten von "Kaufwege PLUS ein
 * unumgehbares Gate" entschieden: die Fussnote informiert vorab auf den drei
 * Routen oben, das Gate erzwingt die Bestaetigung an JEDEM Kaufweg, auch an
 * denen ohne Fussnote.
 *
 * Bewacht wird diese Liste von `src/lib/b2bNotice.routes.test.tsx` — der
 * Test iteriert ECHT ueber `B2B_NOTICE_ROUTES` (kein hartkodierter Pfad je
 * `it(...)`) und rendert fuer jede Route ihren echten Konsumenten (`Auth`
 * fuer `/auth`, `Layout` fuer den Rest). Eine Aenderung an dieser Liste
 * faerbt damit garantiert genau diesen Test, nicht nur die beiden
 * Einzel-Dateien `Layout.b2bNotice.test.tsx`/`Auth.b2bNotice.test.tsx`, die
 * pro Route einen eigenen, von Hand geschriebenen Pfad-String pruefen.
 */
export const B2B_NOTICE_ROUTES = ['/auth', '/pricing', '/settings'] as const;
